/*
  <product-recommendations>

  Carga de forma diferida (cuando el bloque entra en viewport) el HTML que devuelve
  la Section Rendering API en data-url y reemplaza su propio contenido con el.
  Lo usan la seccion "related-products" y el bloque "complementary" de "main-product",
  por eso vive en un asset compartido: definir la misma clase en dos {% javascript %}
  rompe el bundle de secciones (identificador duplicado + customElements.define repetido).
*/
if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.loaded || !this.dataset.url) return;

        const observer = new IntersectionObserver(
          (entries, observerInstance) => {
            if (!entries[0].isIntersecting) return;
            observerInstance.unobserve(this);
            this.loadRecommendations();
          },
          { rootMargin: '0px 0px 200px 0px' }
        );

        observer.observe(this);
      }

      loadRecommendations() {
        this.loaded = true;

        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('product-recommendations: ' + response.status);
            return response.text();
          })
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('product-recommendations');
            if (!recommendations || !recommendations.innerHTML.trim().length) return;

            this.innerHTML = recommendations.innerHTML;
          })
          .catch((error) => {
            // Permite reintentar si el bloque se vuelve a insertar (editor de temas)
            this.loaded = false;
            console.error(error);
          });
      }
    }
  );
}
